import type { TOC } from '@ember/component/template-only';
import { PrismIcon } from '@mylighthouse/prism-ember';

interface SettingsBudgetForecastTableBudgetForecastTdNameSignature {
  Args: {
    cellData: {
      isUnmapped: boolean;
      value: string;
    };
  };
}

const SettingsBudgetForecastTableBudgetForecastTdName = <template>
  <div class="flex items-center gap-100" title={{@cellData.value}}>
    {{#if @cellData.isUnmapped}}
      <PrismIcon @name="warning" @size="small" />
    {{/if}}
    <span class="truncate">
      {{@cellData.value}}
    </span>
  </div>
</template> satisfies TOC<SettingsBudgetForecastTableBudgetForecastTdNameSignature>;

export default SettingsBudgetForecastTableBudgetForecastTdName;
